import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  signal,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { BannersFacade } from '../../../services/banners.facade';

@Component({
  selector: 'app-banners',
  standalone: true,
  imports: [NgTemplateOutlet],
  templateUrl: './banners.component.html',
  styleUrls: ['./banners.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BannersComponent {
  private readonly facade = inject(BannersFacade);

  readonly banners = this.facade.banners;
  readonly isLoading = this.facade.isLoading;

  readonly placeholders = signal(Array.from({ length: 4 }));
}
